import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button, Info } from '@winelidays/wld-tsx-2/elements';
import { useCancellationTexts } from '@winelidays/wld-tsx-2/hooks';
const BookingDetailCancellation = t0 => {
    const $ = _c(22);
    const { cancellation, filters, completion, calculatedPrice, cancellationAmount, className: t1, onCancel, loading } = t0;
    const className = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const eventDate = (completion === true || completion.date) && filters && filters.date && filters.date.startDate || undefined;
    const eventTime = (completion === true || completion.time) && filters && filters.time && filters.time.eventTime && filters.time.eventTime.time || undefined;
    const totalPrice = calculatedPrice?.totalPriceBeforeDiscount ?? (calculatedPrice ? calculatedPrice.subTotal : undefined);
    const bookingFees = calculatedPrice?.fees ?? 0;
    const t2 = cancellation;
    let t3;
    if ($[0] !== bookingFees || $[1] !== cancellationAmount || $[2] !== currencySymbol || $[3] !== eventDate || $[4] !== eventTime || $[5] !== t2 || $[6] !== totalPrice || $[7] !== translate) {
        t3 = {
            bookingFees,
            cancellation: t2,
            eventDate,
            eventTime,
            totalPrice,
            cancellationAmount,
            currencySymbol,
            translate,
            locale: LOCALE
        };
        $[0] = bookingFees;
        $[1] = cancellationAmount;
        $[2] = currencySymbol;
        $[3] = eventDate;
        $[4] = eventTime;
        $[5] = t2;
        $[6] = totalPrice;
        $[7] = translate;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    const { title, description } = useCancellationTexts(t3);
    const computedClassName = `py-4 px-6 border-t border-gray-100 flex flex-col flex-shrink-0 border-0 text-sm lg:!rounded-t-none ${className}`;
    let t4;
    if ($[9] !== loading || $[10] !== onCancel || $[11] !== translate) {
        t4 = onCancel ? <Button className="btn-default mt-4 mb-2 !py-3 !px-6 max-w-max self-center" onClick={onCancel} busy={loading} title={translate("messages.cancel_my_reservation")}>{translate("messages.cancel_my_reservation")}</Button> : null;
        $[9] = loading;
        $[10] = onCancel;
        $[11] = translate;
        $[12] = t4;
    }
    else {
        t4 = $[12];
    }
    const cancelButton = t4;
    let t5;
    if ($[13] !== title) {
        t5 = <span className="font-semibold mb-2 block">{title}</span>;
        $[13] = title;
        $[14] = t5;
    }
    else {
        t5 = $[14];
    }
    let t6;
    if ($[15] !== description) {
        t6 = <span className="block">{description}</span>;
        $[15] = description;
        $[16] = t6;
    }
    else {
        t6 = $[16];
    }
    let t7;
    if ($[17] !== cancelButton || $[18] !== computedClassName || $[19] !== t5 || $[20] !== t6) {
        t7 = <Info className={computedClassName}>{t5}{t6}{cancelButton}</Info>;
        $[17] = cancelButton;
        $[18] = computedClassName;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    }
    else {
        t7 = $[21];
    }
    return t7;
};
export default BookingDetailCancellation;
